import React from "react";
import LandingPage from '../components/landingPage';
import Navbar from '../components/navbar';
import Footer from "../components/footer";

function Home() {
  return (
    <>
      <Navbar />
      <LandingPage />
      <Footer />
    </>
  );
}

export default Home;
